import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import validate from "common/validation";
import { withTranslation } from "react-i18next";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  acceptGraderDiamonds,
  addGraderAssignStockList,
  assignGraderToFillerInWards,
  getInclusion,
  getProcess,
  getShapes,
  getUserByRoleId,
  updateAssignGraderToFillerInWards,
  updateGraderStock,
  updateGraderStockInWard,
} from "api";
import {
  categoriTypes,
  status,
  color,
  purity,
  process,
} from "../StaticData.js";
import { values } from "lodash";

class GraderReassign extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      validation: "",
      isSubmitTrue: true,
      fillerList: [],
      editRowIndex: -1,
      selectorRow: [],
      shapeList: [],
      processList: [],
      previous: props.location.state.previousData,
      inclusionList: [],
      // successTrue: true,
      processId:
        props.location.state.isEdit == 2
          ? props.location.state.data.processId
          : props.location.state.data.assignGraderToFillerInWard.processId,
      shapeId: props.location.state.data.stockGraderInWard.shapeId,
      iColorId: props.location.state.data.stockGraderInWard.iColorId,
      oColorId:
        props.location.state.data.stockGraderInWard.oColorId == 0 ||
        props.location.state.data.stockGraderInWard.oColorId == null
          ? props.location.state.data.stockGraderInWard.iColorId
          : props.location.state.data.stockGraderInWard.oColorId,
       outWardWeight: props.location.state.data.stockGraderInWard.outWardWeight == 0
          ? props.location.state.data.stockGraderInWard.weight
          : props.location.state.data.stockGraderInWard.outWardWeight,
      purityId: props.location.state.data.stockGraderInWard.purityId,
      selectedMulti: null,

      props: props?.location?.state,
      // notEditableRows: props?.location?.query.data.ds.gs.gtf
      //   .reduce((prev, current) => {
      //     return prev.cycle > current.cycle ? prev : current;
      //   })
      //   .assignGraderToFillerInWards.map(x => x.id),
      // stockList: props?.location?.query.data.ds.gs.gtf.reduce(
      //   (prev, current) => {
      //     return prev.cycle > current.cycle ? prev : current;
      //   }
      // ),
    };
    this.filesharhe_ref = createRef();
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }
  async componentDidMount() {
    const data = await getUserByRoleId("ROLE0000003");
    const shape = await getShapes();
    const process =  await getProcess();
    if(process && process.data){
      this.setState({
        processList: process.data
      })
    }
    const inclusionId = await getInclusion();

    this.setState(
      {
        shapeList: shape.data,
        inclusionList: inclusionId.data.map(x => {
          return { label: x.name, value: x.id };
        }),
        fillerList: data.data.users,
      },
      () => {
        this.setState({
          selectedMulti: this.state.inclusionList.length
            ? this.state.inclusionList
                .filter(x =>
                  this.state.props.data.stockGraderInWard.inclusionId.includes(
                    x.value
                  )
                )
                .map(x => {
                  return { label: x.label, value: x.value };
                })
            : [],
        });
      }
    );
  }
  async accept(values) {
    let temp = {
      mainJangadId: this.state.props.data.mainJangadId,
      jangadId: this.state.props.data.jangadId,
      assignGraderToFillerStockId:
        this.state.props.data.assignGraderToFillerStockId,
      assignGraderToFillerInWardId:
        this.state.props.data.assignGraderToFillerInWardId,
      cubeInformationId: this.state.props.data.cubeInformationId,
      dataEntryStockId: this.state.props.data.dataEntryStockId,
      fillerStockId: this.state.props.data.fillerStockId,
      graderStockId: this.state.props.data.graderStockId,
      machineOperatorStockId: this.state.props.data.machineOperatorStockId,
      stockDataEntryInWardId: this.state.props.data.stockDataEntryInWardId,
      stockFillerInWardId: this.state.props.data.stockFillerInWardId,
      stockGraderInWardId: this.state.props.data.stockGraderInWardId,
      cubeBeltId: this.state.props.data.cubeBeltId,
      stockMachineOperatorInWardId: this.state.props.data.id,
      outWardWeight: this.state.outWardWeight,
      outWardPieces: values.outWardPieces,
      nextRemarks: values.nextRemarks,
      oColorId:
        this.state.oColorId == "" ? values.iColorId : this.state.oColorId,
      inclusionId: this.state.selectedMulti.map(y => y.value),
    };

    const data = await acceptGraderDiamonds(temp);
    if (data.success == true) {
      this.setState({
        isSubmitTrue: false,
        previous: {
          ...this.state.previous,
          stockMachineOperatorInWards:
            this.state.previous.stockMachineOperatorInWards.map(x => {
              if (x.id == this.state.props.data.id) x.graderStatus = "A";
              return x;
            }),
        },
      });
    }
  }

  async update(values) {
    let temp = {
      id: this.state.props.data.id,
      weight: this.state.props.data.weight,
      weightType: this.state.props.data.weightType,
      colorId: this.state.props.data.colorId,
      processId: this.state.processId,
      remarks: this.state.props.data.remarks,
      nextRemarks: this.state.props.data.nextRemarks,
      oColorId: this.state.oColorId,
      stockGraderInWardId: this.state.props.data.stockGraderInWardId,
    };
    const data = await updateAssignGraderToFillerInWards(temp);
    if(data.success == true){
      this.setState({
        isSubmitTrue : false
      })
    }
  }

  async reassign(values) {
    let temp = {
      cycle:
        parseInt(this.state.props.data.assignGraderToFillerInWard.cycle) + 1,
      jangadId: this.state.props.data.assignGraderToFillerInWard.jangadId,
      mainJangadId:
        this.state.props.data.assignGraderToFillerInWard.mainJangadId,
      dataEntryStockId:
        this.state.props.data.assignGraderToFillerInWard.dataEntryStockId,
      graderStockId:
        this.state.props.data.assignGraderToFillerInWard.graderStockId,
      stockDataEntryInWardId:
        this.state.props.data.assignGraderToFillerInWard.stockDataEntryInWardId,
      assignGraderToFillerStockId:
        this.state.props.data.assignGraderToFillerInWard
          .assignGraderToFillerStockId,
      stockGraderInWardId:
        this.state.props.data.assignGraderToFillerInWard.stockGraderInWardId,
      fillerStockId: this.state.props.data.fillerStockId,
      graderStockId: this.state.props.data.graderStockId,
      machineOperatorStockId: this.state.props.data.machineOperatorStockId,
      stockDataEntryInWardId: this.state.props.data.stockDataEntryInWardId,
      stockFillerInWardId: this.state.props.data.stockFillerInWardId,
      stockGraderInWardId: this.state.props.data.stockGraderInWardId,
      cubeBeltId: this.state.props.data.cubeBeltId,
      stockMachineOperatorInWardId: this.state.props.data.id,
      weight: this.state.props.data.assignGraderToFillerInWard.weight,
      weightType: this.state.props.data.assignGraderToFillerInWard.weightType,
      colorId: this.state.props.data.assignGraderToFillerInWard.colorId,
      processId: this.state.processId,
      remarks: this.state.props.data.assignGraderToFillerInWard.remarks,
      nextRemarks: values.nextRemarks,
      fillerStatus:
        this.state.props.data.assignGraderToFillerInWard.fillerStatus,
      outWardWeight: this.state.outWardWeight,
      outWardPieces: values.outWardPieces,
      oColorId:
        this.state.oColorId == "" ? values.iColorId : this.state.oColorId,
      inclusionId: this.state.selectedMulti.map(y => y.value),
    };

    const data = await assignGraderToFillerInWards(temp);
    if (data.success == true) {
      this.setState({
        isSubmitTrue : false,
        previous: {
          ...this.state.previous,
          stockMachineOperatorInWards:
            this.state.previous.stockMachineOperatorInWards.map(x => {
              if (x.id == this.state.props.data.id) x.graderStatus = "A";
              return x;
            }),
        },
      });
    }
  }

  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "grader flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Re-Assign Screen")} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  id: this.state.props.data.mainJangad.id,
                  name: this.state.props.data.mainJangad.name,
                  partyCode: this.state.props.data.mainJangad.party.partyCode,
                  fillerId: this.state.props.data.fillerStock.user.name,
                  cycle:
                    this.state.props.isEdit == 2
                      ? this.state.props.data.cycle
                      : this.state.props.data.assignGraderToFillerInWard.cycle,
                  weight: this.state.props.data.stockGraderInWard.weight,
                  srNo: this.state.props.data.stockDataEntryInWard.srNo,
                  outWardWeight: this.state.outWardWeight,
                  pieces: this.state.props.data.stockDataEntryInWard.pieces,
                  outWardPieces:
                    this.state.props.data.stockGraderInWard.outWardPieces == 0
                      ? this.state.props.data.stockDataEntryInWard.pieces
                      : this.state.props.data.stockGraderInWard.outWardPieces,
                  shapeId: this.state.shapeList.length
                    ? this.state.shapeList.filter(
                        x => x.id == this.state.shapeId
                      )[0].name
                    : "",
                  iColorId: this.state.props.data.stockGraderInWard.iColorId,
                  processId: this.state.processId,
                  oColorId: this.state.oColorId,
                  purityId: purity.filter(x => {
                    return x.value == this.state.purityId;
                  })[0].value,
                  inclusionId: this.state.selectedMulti || "",
                  graderNotes: this.state.props.data.remarks,
                  nextRemarks: this.state.props.data.nextRemarks,
                }}
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  partyCode: Yup.string().required("This value is required"),
                  fillerId: Yup.string().required("This value is required"),
                  cycle: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  outWardWeight: Yup.number()
                    .max(this.state.props.data?.stockGraderInWard?.weight)
                    .notRequired(),
                  pieces: Yup.string().required("This value is required"),
                  outWardPieces: Yup.string().notRequired(),
                  shapeId: Yup.string().required("This value is required"),
                  iColorId: Yup.string().required("This value is required"),
                  oColorId: Yup.string().required("This value is required"),
                  purityId: Yup.string().required("This value is required"),
                  inclusionId: Yup.array(),
                  graderNotes: Yup.string().notRequired(),
                })}
              >
                {({ errors, status, touched, values, validateForm }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                            {this.props.t("Re-Assign Screen")}
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Assign Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>

                        <CardBody>
                          <Row>
                            {/* <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="id"
                                  placeholder="XYZ Diamond"
                                />

                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />

                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="srNo"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("SrNo.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.srNo && touched.srNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="srNo"
                                  placeholder="srNo"
                                />
                                <ErrorMessage
                                  name="srNo"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="partyCode"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="fillerId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Filler Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.fillerId && touched.fillerId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="fillerId"
                                  disabled={true}
                                >
                               
                                </Field>
                                <ErrorMessage
                                  name="fillerId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cycle"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Cycle No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cycle && touched.cycle
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="cycle"
                                  placeholder="cycle 1"
                                  readOnly={true}
                                />
                                <ErrorMessage
                                  name="cycle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="pieces"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Pieces")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.pieces && touched.pieces
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="pieces"
                                  placeholder="pieces"
                                  readOnly={true}
                                />
                                <ErrorMessage
                                  name="pieces"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="outWardPieces"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("OutWard Pieces")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.outWardPieces &&
                                    touched.outWardPieces
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="outWardPieces"
                                  placeholder="outWardPieces"
                                />
                                <ErrorMessage
                                  name="outWardPieces"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="weight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Weight")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.weight && touched.weight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="weight"
                                  placeholder="20.25 CT"
                                />
                                <ErrorMessage
                                  name="weight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="outWardWeight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("OutWard Weight")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.outWardWeight &&
                                    touched.outWardWeight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.outWardWeight}
                                  onChange={(e) => {
                                    this.setState({
                                      outWardWeight: e.target.value
                                    })
                                  }}
                                  readOnly={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="outWardWeight"
                                  placeholder="outWardWeight"
                                />
                                <ErrorMessage
                                  name="outWardWeight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                           

                            <div className="mb-3 row">
                              <Label
                                htmlFor="shapeId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Shape")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    `form-control ${
                                      this.state.props.isEdit == 3
                                        ? ""
                                        : "form-select"
                                    }  fs-5` +
                                    (errors.shapeId && touched.shapeId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.shapeId}
                                  name="shapeId"
                                  as="select"
                                  disabled={true}
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.shapeList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="shapeId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="iColorId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Color")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    `form-control ${
                                      this.state.props.isEdit == 3
                                        ? ""
                                        : "form-select"
                                    }  fs-5` +
                                    (errors.iColorId && touched.iColorId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.iColorId}
                                  name="iColorId"
                                  as="select"
                                  disabled={true}
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {color?.map(x => (
                                    <option key={x.value} value={x.value}>
                                      {x.label}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="iColorId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="processId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Process")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    `form-control ${
                                      this.state.props.isEdit == 3
                                        ? ""
                                        : "form-select"
                                    }  fs-5` +
                                    (errors.processId && touched.processId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.processId}
                                  onChange={e => {
                                    console.log(e.target.value)
                                    this.setState({
                                      processId: e.target.value,
                                    });
                                  }}
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  name="processId"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.processList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="processId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="oColorId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("OutWard Color")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    `form-control ${
                                      this.state.props.isEdit == 3
                                        ? ""
                                        : "form-select"
                                    }  fs-5` +
                                    (errors.oColorId && touched.oColorId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.oColorId}
                                  onChange={e => {
                                    this.setState({ oColorId: e.target.value });
                                  }}
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  name="oColorId"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {color?.map(x => (
                                    <option key={x.value} value={x.value}>
                                      {x.label}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="oColorId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="purityId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Purity")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    `form-control ${
                                      this.state.props.isEdit == 3
                                        ? ""
                                        : "form-select"
                                    }  fs-5` +
                                    (errors.purityId && touched.purityId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.purityId}
                                  onChange={e =>
                                    this.setState({ purityId: e.target.value })
                                  }
                                  name="purityId"
                                  as="select"
                                  disabled={true}
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {purity?.map(x => (
                                    <option key={x.value} value={x.value}>
                                      {x.label}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="purityId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="inclusionId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Inclusion Name")}
                                </h5>
                              </Label>
                              {this.state.props.isEdit == 3 ? (
                                <div className="col-md-10">
                                  <Field
                                    type="text"
                                    className={
                                      "form-control fs-5" +
                                      (errors.graderNotes && touched.graderNotes
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={this.state.selectedMulti?.map(x => {
                                      return x.label;
                                    })}
                                  />
                                  <ErrorMessage
                                    name="inclusionId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              ) : (
                                <div className="col-md-10">
                                  <Select
                                    value={this.state.selectedMulti}
                                    isMulti={true}
                                    isSearchable={false}
                                    onChange={e => {
                                      console.log(this.state.selectedMulti);
                                      this.setState({ selectedMulti: e });
                                    }}
                                    options={this.state.inclusionList}
                                  />

                                  <ErrorMessage
                                    name="inclusionId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              )}
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="graderNotes"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Grader Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.graderNotes && touched.graderNotes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="graderNotes"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                  readOnly={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                />
                                <ErrorMessage
                                  name="graderNotes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {this.state.props.isEdit == 1 ? "" : <div className="mb-3 row">
                              <Label
                                htmlFor="nextRemarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Filler Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.nextRemarks && touched.nextRemarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="nextRemarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="nextRemarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>}
                            
                          </Row>
                        </CardBody>
                      </div>
                      <div className="col-md-12 text-center text-md-end mt-4 pb-5 px-3">
                        {this.state.props.isEdit == 3 && (
                          <Button
                            color="primary"
                            className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                            onClick={() => {
                              this.props.history.push({
                                pathname: "/grader-process-stock-accept-reject",
                                query: {
                                  data: this.state.previous,
                                  isEdit: 2,
                                },
                              });
                            }}
                          >
                            Back
                          </Button>
                        )}

                        {this.state.props.isEdit == 2 && (
                          <>
                            <Button
                              color="primary"
                              className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                              onClick={() => {
                                this.props.history.goBack();
                              }}
                            >
                              Back
                            </Button>
                            {this.state.isSubmitTrue == true ?  <Button
                              color="primary"
                              className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                              type="submit"
                              onClick={() => {
                                validateForm()
                                  .then(data => {
                                    console.log(data);
                                    if (Object.keys(data).length == 0) {
                                      this.update(values);
                                    }
                                  })
                                  .catch(err => console.log(err));
                              }}
                            >
                              Update
                            </Button> : ""}
                           
                          </>
                        )}

                        {this.state.props.isEdit == 1 && (
                          <>
                            <Button
                              color="primary"
                              className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                              onClick={() => {
                                this.props.history.push({
                                  pathname:
                                    "/grader-process-stock-accept-reject",
                                  query: {
                                    data: this.state.previous,
                                    isEdit: 2,
                                  },
                                });
                              }}
                            >
                              Back
                            </Button>
                            {this.state.isSubmitTrue == true ? <Button
                              color="primary"
                              className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                              type="submit"
                              onClick={() => {
                                validateForm()
                                  .then(data => {
                                    console.log(data);
                                    if (Object.keys(data).length == 0) {
                                      this.accept(values);
                                    }
                                  })
                                  .catch(err => console.log(err));
                              }}
                            >
                              Accept
                            </Button> : ""}
                            
                          </>
                        )}

                        {this.state.props.isReject == 1 && (
                          <>
                            <Button
                              color="primary"
                              className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                              onClick={() => {
                                this.props.history.push({
                                  pathname:
                                    "/grader-process-stock-accept-reject",
                                  query: {
                                    data: this.state.previous,
                                    isEdit: 2,
                                  },
                                });
                              }}
                            >
                              Back
                            </Button>
                            {this.state.isSubmitTrue == true ?  <Button
                              color="primary"
                              className="fs-4 border-0 px-5 me-0 me-md-3 fw-bold"
                              type="submit"
                              onClick={() => {
                                validateForm()
                                  .then(data => {
                                    if (Object.keys(data).length == 0) {
                                      this.reassign(values);
                                    }
                                  })
                                  .catch(err => console.log(err));
                              }}
                            >
                              Reassign
                            </Button> : ""}
                           
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(GraderReassign);
